export default __webpack_public_path__ + "static/media/cl14.f580a960.webp";